import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExpenseDetailRequestService } from './expenserequest.service';
import { global } from '../../../shared/global';
import { ExpenseDetail } from '../../Models/ExpenseDetail.model';
declare var $: any;

@Component({
  selector: 'app-expenserequest',
  templateUrl: './expenserequest.component.html',
  styleUrls: ['./expenserequest.component.css']
})
export class ExpenserequestComponent implements OnInit {
  @ViewChild('expenseDetail') expenseDetail: NgForm;
  searchtext;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  data: ExpenseDetail;
  submitted: boolean;
  HashCode: any;
  ExpenseDetaillist: any;
  btnsubmittext: string = "Submit";
  schoolname: any;
  yearlist: any;
  expenses: any;
  yearid: string;
  totalExpense:any;
  totalPages = 10;

  constructor(private service: ExpenseDetailRequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/collegelogin']);
      return;  
    }
    document.getElementById('YearID').addEventListener('change', () => {
     this.getExpenseDetailList(this.p)
});
    this.data = new ExpenseDetail();
    $("#searchtext").val("");
    this.fillYear();
    this.fillExpenseType();

    // var dtToday = new Date();
    // var month: string = (dtToday.getMonth() + 1).toString();
    // var day: string = (dtToday.getDate()).toString();
    // var year: string = (dtToday.getFullYear()).toString();
    // if (parseInt(month) < 10)
    //   month = '0' + month.toString();
    // if (parseInt(day) < 10)
    //   day = '0' + day.toString();
    // var maxDate = year + '-' + month + '-' + day;
    // $('#ExpenseDate').attr('max', maxDate);
  }

  fillYear() {
    const data = {
    };
    this.service.fillYear(data)
      .subscribe(data => {
        this.yearlist = data["dropdownlist"];
        this.yearid = localStorage.getItem("yearID");
        this.getExpenseDetailList(this.p)
      });
  }

  fillExpenseType() {
    const data = {
    };
    this.service.fillExpenseType(data)
      .subscribe(data => {
        this.expenses = data["dropdownlist"];
        this.data.ExpenseTypeID = 0;
      });
  }

  getExpenseDetailList(page) {
    this.spinner.show();
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      yearID: this.yearid,
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit
    };
    this.service.getExpenseDetailRequestList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.ExpenseDetaillist = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.ExpenseDetaillist = this.responseData.expenseDetailListRequests;
          this.totalExpense = this.responseData.totalCount;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  onSubmit() {
    if (this.data.ExpenseTypeID == 0 || this.data.ExpenseTypeID == undefined || this.data.ExpenseAmount == 0 || this.data.ExpenseAmount == undefined 
      || this.data.TaxByTrust == 0 || this.data.TaxByTrust == undefined || this.data.TaxByCollege == 0 || this.data.TaxByCollege == undefined
      || this.data.StudentInsurance == 0 || this.data.StudentInsurance == undefined || this.data.TeachingInsurance == 0 || this.data.TeachingInsurance == undefined ||
      this.data.NonTeachingInsurance == 0 || this.data.NonTeachingInsurance == undefined || this.data.BuildingInsurance == undefined || this.data.BuildingInsurance == 0) {
      return;
    }

    this.submitted = true;
    this.data.HashCode = this.HashCode;
    this.data.YearID = parseInt(localStorage.getItem("yearID"))

    if (this.expenseDetail.valid) {
      this.spinner.show();
      this.service.saveExpenseDetailRequest(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getExpenseDetailList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  editExpenseDetail(HashCode) {
    const data = {
      HashCode: HashCode,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getExpenseDetailRequestByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  deleteExpenseDetail(HashCode) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode
      }
      this.spinner.show();
      this.service.deleteExpenseDetailRequest(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getExpenseDetailList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  resetForm() {
    this.data.ID = 0;
    this.data.ExpenseTypeID = 0;
    this.data.ExpenseAmount = null;
    // this.data.LumsumMaintanance = null;
    this.data.TaxByTrust = null;
    this.data.TaxByCollege = null;
    this.data.StudentInsurance = null;
    this.data.TeachingInsurance = null;
    this.data.NonTeachingInsurance = null;
    this.data.BuildingInsurance = null;
    this.submitted = false;
    this.btnsubmittext = "Submit";
  }

  onlyDouble(evt, val) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    if (charCode == 46 && val != undefined && String(val).includes('.'))
      return false;
    var i = String(val).indexOf('.');
    if (i > 0 && String(val).length > i + 2)
      return false
    return true;
  }

  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.ExpenseDetaillist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }
}
